import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { useDispatch, useSelector } from "react-redux";
import { getTopic } from "@store/action/smartend/TopicAction";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
} from "swiper";
SwiperCore.use([
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
]);
const params = {
  slidesPerView: 3,
  spaceBetween: 30,
  pagination: false,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  navigation: false,
};

const BlogSection = ({ t }) => {
  const store = useSelector((state) => state.NewsReducer);
  const news = store?.data;
  const lang = localStorage.getItem("lang") || "en";
  const lang1 = lang.substring(1, lang.length - 1) || "en";
  const dispatch = useDispatch();
  const webmasterTitle = "News";
  useEffect(() => {
    dispatch(
      getTopic(webmasterTitle, {
        page: 1,
        per_page: 5,
      })
    );
  }, [dispatch]);
  const renderData = () => {
    if (news.data?.length) {
      return news?.data?.map((item, i) => {
        return (
          <SwiperSlide key={i}>
            <div className="blog-card">
              <img src={item.photo_file && item.photo_file} />
              <div className="blog-overlay">
                <p>
                  {new Date(item.date).toLocaleString(`${lang1}-US`, {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
                <Link
                  className="btn btn-outline"
                  to={`/dataNews/News/topics/${item.id}`}
                >
                  {t("read more")}
                </Link>
              </div>
            </div>
          </SwiperSlide>
        );
      });
    }
  };

  return (
    <section className="section blog-part">
      <div className="container__video">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-heading">
              <h2>{t("Recent Articles")}</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="team-slider slider-arrow">
              <Swiper {...params}>{renderData()}</Swiper>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="blog-btn">
              <Link className="btn btn-outline" to="/dataNews/Blog/topics">
                <i className="fa fa-eye me-1"></i>
                <span>{t("show more")}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
